/**
 * Icon path mapping for cacheable SVG icons (public/icons/).
 * Use with <Icon name="..." variant="..." /> or getIconSrc() for <img>.
 */

export type IconVariant = 'outline' | 'solid';

/** Kebab-case icon file names used in public/icons/{outline|solid}/ */
const ICON_FILES: Record<string, string> = {
  mapPin: 'map-pin',
  bookmark: 'bookmark',
  briefcase: 'briefcase',
  wifi: 'wifi',
  globeAlt: 'globe-alt',
  clock: 'clock',
  ellipsisVertical: 'ellipsis-vertical',
  chevronLeft: 'chevron-left',
  chevronRight: 'chevron-right',
  chevronDown: 'chevron-down',
  chevronUp: 'chevron-up',
  buildingOffice2: 'building-office-2',
  chartBar: 'chart-bar',
  currencyDollar: 'currency-dollar',
  funnel: 'funnel',
  arrowUpOnSquare: 'arrow-up-on-square',
  checkCircle: 'check-circle',
  eyeSlash: 'eye-slash',
  xCircle: 'x-circle',
  xMark: 'x-mark',
  home: 'home',
  arrowLeft: 'arrow-left',
  check: 'check',
  informationCircle: 'information-circle',
  sparkles: 'sparkles',
  magnifyingGlass: 'magnifying-glass',
  bars3: 'bars-3',
  facebook: 'facebook',
  linkedin: 'linkedin',
  reddit: 'reddit',
  squares2x2: 'squares-2x2',
  bars4: 'bars-4',
  arrowLongUp: 'arrow-long-up',
};

export type IconName = keyof typeof ICON_FILES;

/**
 * Returns the public URL for an icon SVG (cacheable by the browser).
 */
export function getIconSrc(name: IconName, variant: IconVariant = 'outline'): string {
  const file = ICON_FILES[name];
  if (!file) return '';
  return `/icons/${variant}/${file}.svg`;
}
